<template>
  <v-list-item
    v-if="!item.children"
    class="py-2"
    :link="item.route"
    color="primary"
    v
    @click.native="handleItemClick(item)"
  >
    <v-list-item-icon>
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>{{ item.name }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>

  <v-list-group v-else no-action :prepend-icon="item.icon" :value="false">
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <template v-for="(childItem, index) in item.children">
      <v-list-item
        v-if="$check(menuOption.path, 'GET')"
        :link="childItem.route"
        @click.native="handleItemClick(childItem)"
        :key="index"
        color="red"
      >
        <v-list-item-content>
          <v-list-item-title>{{ childItem.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list-group>
</template>

<script>
import { eventHub } from "@/main";

export default {
  name: "MenuItem",

  props: ["item"],

  methods: {
    handleItemClick(item) {
      if (item.event) {
        eventHub.$emit(item.event);
      } else {
        eventHub.$emit("close-menu");
      }

      // Navigate to the item's route if it has a route
      if (item.route) {
        this.$router.push(item.route);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Estilos opcionais aqui */
</style>
